<header class="it25-menu">
    <div class="it-header-slim-wrapper it25-top-bar">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="it-header-slim-wrapper-content">
                        <a class="navbar-brand" aria-label="Vai a regione" href="https://www.regione.lombardia.it/" target="_blank">
                            <img src="assets/img/logo-rl-bianco.png" alt="Logo Regione Lombardia" class="d-md-none">
                        </a>
                        <div class="header-slim-right-zone">
                            <a *ngIf="utenteService.logged" class="btn btn-primary btn-icon btn-full" title="Ritorna al portale" aria-label="Ritorna al portale" (click)="logout()">
                                <app-toolkit-bl-icon icon="arrow-left" cssClass="icon icon-white"></app-toolkit-bl-icon>
                                <span class="d-none d-md-block">Ritorna al portale</span>
                            </a>
                            <a *ngIf="!utenteService.logged" class="btn btn-primary btn-icon btn-full" title="Accedi all'area personale" aria-label="Accedi all'area personale" (click)="login()">
                                <app-toolkit-bl-icon icon="user" cssClass="icon icon-white"></app-toolkit-bl-icon>
                                <span class="d-none d-md-block">Accedi</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="it-header-center-wrapper it25-barra-ist">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="it-header-center-content-wrapper">
                        <div class="it-brand-wrapper">
                            <div class="it25-hamburger-btn-wrapper d-lg-none" *ngIf="utenteService.isEnabled()">
                                <button (click)="showMobileMenu = !showMobileMenu" [attr.aria-expanded]="showMobileMenu" aria-label="Apri menù" class="custom-navbar-toggler btn btn-xs it25-btn-menu" type="button">
                                    <app-toolkit-bl-icon icon="burger"></app-toolkit-bl-icon>
                                </button>
                                <div class="it25-close-div">
                                    <button (click)="showMobileMenu = !showMobileMenu" class="btn btn-xs close-menu" type="button" aria-label="Chiudi menù">
                                        <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
                                    </button>
                                </div>
                            </div>
                            <a routerLink="/">
                                <img src="assets/img/logo-rl.png" alt="Logo Regione Lombardia" class="it25-header-logo d-none d-md-block">
                                <div class="it-brand-text d-none d-md-block">{{ appNameDesktop }}</div>
                                <div class="it-brand-text d-block d-md-none">{{ appNameMobile }}</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="it25-barra-utente" *ngIf="utenteService.isEnabled() && utenteService.logged">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <app-toolkit-bl-icon icon="user" cssClass="icon icon-primary icon-xs"></app-toolkit-bl-icon>
                    <span class="font-weight-light">Utente: </span><span class="font-weight-semibold"><a style="color: #455b71;" [routerLink]="['private/gestione-utente/profilo']">{{ utenteService.utente.nome }} {{ utenteService.utente.cognome }}</a></span>
                    <span class="ml-2 font-weight-light" *ngIf="datalist.ente?.length">Ente: </span><span class="font-weight-semibold">{{ utenteService.utente.ente | anagraficaEnte: (datalist.ente || []) }}</span>
                    <span class="ml-2 font-weight-light" *ngIf="datalist.ruolo?.length">Ruolo: </span><span class="font-weight-semibold">{{ utenteService.utente.ruolo | anagraficaRuolo: (datalist.ruolo || []) }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="it-header-navbar-wrapper it25-menu-principale" *ngIf="utenteService.isEnabled() && utenteService.logged">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <nav class="navbar navbar-expand-lg">
                        <div class="navbar-collapsable" [class.d-block]="showMobileMenu" [class.expanded]="showMobileMenu" id="it25-main-nav">
                            <div class="overlay it25-overlay" [class.d-block]="showMobileMenu"></div>
                            <div class="close-div sr-only">
                                <button class="btn close-menu" type="button"><span class="it-close"></span>Chiudi</button>
                            </div>
                            <div class="menu-wrapper">
                                <ul class="navbar-nav">
                                    <li class="nav-item"><a class="nav-link" [routerLink]="['private/gestione-opera/ricerca']" routerLinkActive="active"><span>Gestione Opere</span></a></li>
                                    <li class="nav-item"><a class="nav-link" [routerLink]="['private/gestione-progetto']" routerLinkActive="active"><span>Gestione Progetti</span></a></li>
                                    <li class="nav-item"><a class="nav-link" [routerLink]="['private/gestione-rilievo']" routerLinkActive="active"><span>Gestione Rilievi</span></a></li>
                                    <!-- <li class="nav-item"><a class="nav-link" [routerLink]="['private/viewer']"><span>Viewer</span></a></li> -->
                                    <li #dropdown="ngbDropdown" (keydown.enter)="dropdown.toggle()" tabindex="0" class="nav-item dropdown" ngbDropdown *ngIf="utenteService.isRuoloAmministratore()">
                                        <a #anchorDropDown class="nav-link dropdown-toggle" ngbDropdownToggle>
                                            <span>Amministrazione</span>
                                            <app-toolkit-bl-icon icon="expand" cssClass="icon icon-xs"></app-toolkit-bl-icon>
                                        </a>
                                        <div class="dropdown-menu" ngbDropdownMenu>
                                            <div class="link-list-wrapper">
                                                <ul class="link-list">
                                                    <li><a #a (keydown.enter)="a.click()" class="list-item" ngbDropdownItem [routerLink]="['/private/gestione-opera/approva-opera']"><span>Approva opere</span></a></li>
                                                    <!-- <li><a #b (keydown.enter)="b.click()" class="list-item" ngbDropdownItem [routerLink]="['/private/gestione-utente/approva-utente']"><span>Approva utente</span></a></li>
                                                    <li><a #c (keydown.enter)="c.click()" class="list-item" ngbDropdownItem [routerLink]="['/private/gestione-utente/ricerca']"><span>Gestione utenti</span></a></li> -->
                                                    <li><a #d (keydown.enter)="d.click()" class="list-item" ngbDropdownItem [routerLink]="['/private/gestione-anagrafica/ricerca']"><span>Gestione atti di finanziamento</span></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</header>